export default "__VITE_ASSET__HMThjwq7__"